/** Minimal grid + polygon helpers for Lite flow (mirrors Analysis.jsx). */

export function pointInPolygon([px, py], ring) {
  if (!ring?.length) return false;
  let inside = false;
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const [xi, yi] = ring[i];
    const [xj, yj] = ring[j];
    if ((yi > py) !== (yj > py) && px < ((xj - xi) * (py - yi)) / (yj - yi) + xi) inside = !inside;
  }
  return inside;
}

/** GeoJSON Polygon coordinates: [outer, ...holes] */
function pointInPolygonRings(pt, rings) {
  if (!rings?.length) return false;
  const outer = rings[0];
  if (!pointInPolygon(pt, outer)) return false;
  for (let i = 1; i < rings.length; i++) {
    if (pointInPolygon(pt, rings[i])) return false;
  }
  return true;
}

export function pointInPolygonGeometry(pt, geometry) {
  if (!geometry) return false;
  if (geometry.type === "Polygon") {
    return pointInPolygonRings(pt, geometry.coordinates);
  }
  if (geometry.type === "MultiPolygon") {
    for (const poly of geometry.coordinates) {
      if (pointInPolygonRings(pt, poly)) return true;
    }
  }
  return false;
}

export function gridId(lng, lat) {
  const n = Math.abs(Math.round(lng * 1e4) * 31337 + Math.round(lat * 1e4) * 7919) % 9999999;
  return `GR${String(n).padStart(7, "0")}`;
}

export function findGridCellAtPoint(lng, lat, gridGeojson) {
  if (!gridGeojson?.features) return null;
  for (const f of gridGeojson.features) {
    const ring = f.geometry?.coordinates?.[0];
    if (ring && pointInPolygon([lng, lat], ring)) return f;
  }
  return null;
}

